import { createStore as _createStore, applyMiddleware } from 'redux';
import { createBrowserHistory, createMemoryHistory } from 'history';
import analyticActionMapper from './middleware/analyticsActionMapper';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from './middleware/logger';
import { createMiddleware as createSentryMiddleware } from '@/utils/errorTracking';
import { createTracker } from 'redux-segment';
import lux from './middleware/lux';
import { routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';

/**
 * Returns a React-Router MemoryHistory if on the server or BrowserHistory if on the client
 */
type CreateHistoryParams = { basename: string; entries?: any };
export const createHistory = ({ basename, entries }: CreateHistoryParams) => {
    const isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);

    /**
     * Create shared history module between client and server
     * @see https://github.com/supasate/connected-react-router#step-2
     */
    // @ts-ignore
    const history = isServer ? createMemoryHistory({ basename, entries }) : createBrowserHistory({ basename });
    return history;
};

/**
 * Creates a redux store
 */
type CreateStoreParams = { history: any; initialData: any };
export const createStore = ({ history, initialData }: CreateStoreParams) => {
    // middlewares
    const middleware = [routerMiddleware(history), thunkMiddleware, lux];

    // @ts-ignore
    if (__DEVELOPMENT__) {
        middleware.push(createLogger({ client: false, server: false }));
    } else {
        middleware.push(createTracker(analyticActionMapper));
    }

    const sentryMiddleware = createSentryMiddleware();
    if (sentryMiddleware) {
        middleware.push(sentryMiddleware);
    }

    // enhancers
    let enhancers = [applyMiddleware(...middleware)];

    const compose = composeWithDevTools({});
    const finalCreateStore = compose(...enhancers)(_createStore);

    const reducer = require('./rootReducer').default;
    // @ts-ignore
    const store = finalCreateStore(reducer(history), initialData);
    return store;
};
